import { ZIFEK_VERSION, getBuildLabel, getFullVersionInfo } from '@/lib/platformVersion';

// ============================================================
// Badge de version de la plateforme, affiché au pied des menus de
// navigation. La version change automatiquement à chaque mise à jour
// déployée depuis le conteneur (rebuild → nouvel identifiant de build).
// ============================================================

interface PlatformVersionBadgeProps {
  className?: string;
  /** Affiche la version en clair (true) ou seulement le build (false). */
  showVersion?: boolean;
}

export default function PlatformVersionBadge({ className = '', showVersion = true }: PlatformVersionBadgeProps) {
  return (
    <div
      className={`flex items-center justify-center gap-1 text-[10px] font-medium text-foreground-300 select-none ${className}`}
      title={getFullVersionInfo()}
    >
      <i className="ri-code-box-line text-[11px]"></i>
      <span>{showVersion ? `Zifek v${ZIFEK_VERSION}` : `v${ZIFEK_VERSION}`}</span>
      <span className="opacity-60">· {getBuildLabel()}</span>
    </div>
  );
}